import Navbar from '../navbar/Navbar';
import Sidemenu from '../sidemenu/Sidemenu';
import { Button, Grid, Grid2, Typography, Stack, Pagination, Avatar, FormControl, InputLabel, Select, MenuItem, IconButton, Paper, Snackbar, Modal, Box, Rating } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TablePagination } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import prevIcon from '../../assets/icons/left-arrow.svg'
import CloseIcon from '@mui/icons-material/Close';
import nextIcon from '../../assets/icons/right-arrow.svg';
import starIcon from '../../assets/icons/starIcon.png';
import VisibilityIcon from '@mui/icons-material/Visibility';
import defaultImg from '../../assets/images/defaultimg.png';
import { CSVLink } from "react-csv";
import axios from 'axios';
import {
    makeGetRequestToUrl,
    makePostRequestToUrl,
    importCSV,
    parseCSVLine,
    handleImportCSVWithCaseInsensitive,
    processBulkImport
} from '../commonFunc.jsx';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import TokenError from '../tokenError';
import config from '../../config/config.js';
import ActionButtonIcon from '../../assets/icons/Action_Button.svg';
import BackIcon from '../../assets/icons/back.svg';
import Vehiclertypecar from '../../assets/images/vehicleTypeCar.svg';
import Pickupicon from '../../assets/icons/PickupIcon.svg';
import Dropicon from '../../assets/icons/DropIcon.svg';
import { taxiEngagementStatus } from '../../constant.js';
import ConnectionIcon from '../../assets/icons/connection.svg';
import ChatService from './chatservice';
import altProfile from '../../assets/images/altProfile.png';
import { usePDF } from "react-to-pdf";

var constant = require('../../constant.js');

const UserLogs = () => {
    const navigate = useNavigate();
    const [tokenExpired, setTokenExpired] = useState(false);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('request_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [open, setOpen] = useState(false);
    const [detailsOpen, setDetailsOpen] = useState(false);
    const toggleButtonRef = useRef(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [OpenChat, setOpenChat] = useState(false);
    const chatWidth = detailsOpen ? "55%" : "77.5%";
    const [usercustomerchatdata,setUserCustomerChatData] = useState([]);
    const [startDateFilter,setStartDateFilter] = useState(dayjs().subtract(1, 'month'));
    const [endDateFilter, setEndDateFilter] = useState(dayjs());
    const [rows,setRows] = useState([]);
    const [selectedengagementId,setSelectedengagementId] = useState('');
    const [usercustomdata,setUserCustomData] = useState([]);
    const { toPDF, targetRef } = usePDF({
    filename: `chat_export_of_${selectedengagementId || 'all'}.pdf`,
    page: {
        margin: 10,
        format: 'a4',
        orientation: 'portrait'
    }
});


    const handleFilterChange = (filterType, value) => {
        if (filterType === 'city') {
            setCityFilter(value);
        }
    };
    const handleRequestSort = (field) => {
        const isAsc = orderBy === field && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(field);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        showSnackbar(false);
    };

    const handleViewChat = (row) => {
        console.log(row, "row");
        setSelectedengagementId(row.engagement_id);
        setOpenChat(true);
        setSelectedRow(row);
    };


    const handleCloseModal = () => {
        setSelectedengagementId('');
        setOpenChat(false);
    };

    const handleActiveButtonClick = () => {
        console.log("Active button clicked");
        setDetailsOpen(true);
    };

    const handleCloseDetails = () => {
        setDetailsOpen(false);
    };
    const handleOpenMenu = (row) => {
        setSelectedRow(row);
        toggleButtonRef.current = row;
        setOpen(true);
    };

    const handleCloseMenu = () => {
        setOpen(false);
    };

    const formatChatDataForExport = (chatData) => {
        if (!chatData) return [];
                console.log("chatData:", chatData);
        const { 
            engagement_id,
            engagement_details, 
            driver_details, 
            user_details, 
            chat_messages = [] 
        } = chatData;

        // Format chat messages with user/driver info
        const formattedMessages = chat_messages.map(msg => ({
            'Timestamp': new Date(msg.created_at).toLocaleString(),
            'Sender': msg.sender_type === 1 ? 'User' : 'Driver',
            'Message': msg.message,
            'Engagement ID': engagement_id,
            // 'Status': engagement_details?.status,
            'Driver Name': driver_details?.driver_name,
            'Driver ID': driver_details?.driver_id,
            'Driver Phone': driver_details?.driver_phone_number,
            'User Name': user_details?.user_name,
            'User ID': user_details?.user_id,
            'User Phone': user_details?.user_phone_number,
            'Pickup Location': engagement_details?.pickup_address,
            'Drop Location': engagement_details?.drop_address,
            'Vehicle Type': engagement_details?.vehicle_type,
            'Ride Distance': engagement_details?.ride_distance,
            'Fare': usercustomdata?.payment_details?.trip_fare,
            // 'Payment Status': usercustomdata?.payment_details?.payment_status,
        }));

        return formattedMessages;
    };

     const fetchUserCustomerLogs = async() => {
        try {
            const url = serverUrl + `/panel/fetch_user_chat_logs`;
            const timestamp = new Date().getTime();
            const token = localStorage.getItem('token');
            let body = {
                token: token,
                start_date: startDateFilter.format('YYYY-MM-DD'),
                end_date: endDateFilter.format('YYYY-MM-DD'),
            };
            if(selectedengagementId){
                body.engagement_id = selectedengagementId;
            }
            
            const response = await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                if(!selectedengagementId){

                    const usercustomerchatdata = response.data;
                    setUserCustomerChatData(usercustomerchatdata);
                    setRows(usercustomerchatdata);
                }else{
                    const usercustomdata = response.data;
                    setUserCustomData(usercustomdata);
                }
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }


    useEffect(() => {
        fetchUserCustomerLogs();
    }, [cityFilter,startDateFilter,endDateFilter,selectedengagementId]);

    return (
        <div>
            {tokenExpired && <TokenError />}

            <Typography style={{ fontSize: "28px", fontWeight: "500" }}>
                Driver-User Chat Logs
            </Typography>

            <Grid2 container spacing={2} direction="row" alignItems="center" wrap="nowrap"
                style={{ marginTop: "2%", marginBottom: "2%" }}
            >
                <Grid2>
                    <Select value={cityFilter} onChange={(e) => handleFilterChange('city', e.target.value)} displayEmpty
                        style={{
                            width: '200px', height: '46px', borderRadius: '8px', backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">All</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_id} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                {/* <Grid2 xs="auto">
            <input type="number" placeholder="Driver Id" className="filterBtn" value={} onChange={} min="0" 
              onKeyDown={(e) => {
                if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                  e.preventDefault();
                }
              }}
            />
          </Grid2> */}
                {/* <Grid2 xs="auto">
            <input type="number" placeholder="Phone Number" className="filterBtn"value={driverPhone} onChange={handlePhoneChange} />
          </Grid2> */}
                {/* <Grid2 item>
                <Select value={activeStatusFilter} 
                onChange={(e) => setActiveStatusFilter(e.target.value)} displayEmpty
                style={{width: '140px',height:'46px',borderRadius:'8px',backgroundColor: activeStatusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="1">Activated</MenuItem>
                    <MenuItem value="2">Deactivated</MenuItem>
                </Select>
            </Grid2> */}
            <Grid2 item xs="auto" sx={{ display: 'flex', alignItems: 'center' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                    slotProps={{ textField: { size: 'small' } }}
                    sx={{
                        width: 'auto',
                        '& .MuiInputBase-root': {
                        height: '50px',
                        borderRadius: '8px',
                        backgroundColor: '#FFFFFF',
                        }
                    }}
                    value={startDateFilter}
                    onChange={(newValue) => setStartDateFilter(newValue)}
                    minDate={endDateFilter.subtract(45, 'day')}
                    maxDate={endDateFilter}
                    />
                </LocalizationProvider>
            </Grid2>

            <Grid2 item xs="auto" sx={{ display: 'flex', alignItems: 'center' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                    slotProps={{ textField: { size: 'small' } }}
                    sx={{
                        width: 'auto',
                        '& .MuiInputBase-root': {
                        height: '50px',
                        borderRadius: '8px',
                        backgroundColor: '#FFFFFF',
                        }
                    }}
                    value={endDateFilter}
                    onChange={(newValue) => {
                        const daysDiff = newValue.diff(startDateFilter, 'days');
                    
                        setEndDateFilter(newValue);
                    
                        if (daysDiff > 45) {
                            setStartDateFilter(newValue.clone().subtract(45, 'days'));
                        }
                    }}
                    minDate={startDateFilter}
                    />
                </LocalizationProvider>
            </Grid2>


            </Grid2>
        
            <TableContainer className="table-container" sx={{ maxHeight: '72vh', overflowX: 'auto' }}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '150px' }}>
                                <TableSortLabel active={orderBy === 'plan_id'} direction={orderBy === 'plan_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('plan_id')}>
                                    Engagement ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '120px' }}>
                               Status
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '80px' }}>Driver ID</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '120px' }}>User ID</TableCell>

                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '200px' }}>Last Message Preview</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '150px' }}>Date & Time</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '80px' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={7} align="center">
                                   {`No Chat Logs available for the ${startDateFilter?.format('YYYY-MM-DD')} to ${endDateFilter?.format('YYYY-MM-DD')} date range. Please adjust your filters.`}
                                </TableCell>
                            </TableRow>
                        )
                        : rows?.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell align="center">{row.engagement_id}</TableCell>
                                <TableCell align="center">{constant.taxiEngagementStatusReverse[row.engagement_details.engagement_status]}</TableCell>
                                <TableCell>
                                    <Grid2 container sx={{ width: 'auto', minWidth: '180px' }}>
                                        <Grid2>
                                            <Avatar sx={{ borderColor: '#0065FF', border: 1 }} alt="driver image" src={row.driver_details.driver_image || altProfile} />
                                        </Grid2>
                                        <Grid2 item sx={{ ml: '8px', textAlign: 'left' }}>
                                            <Grid2>
                                                <Typography>{row.driver_details.driver_name}</Typography>
                                            </Grid2>
                                            <Grid2>
                                                <Typography sx={{ color: '#83888E', fontSize: '12px' }}>
                                                    {row.driver_details.driver_phone_number}
                                                </Typography>
                                            </Grid2>
                                        </Grid2>
                                    </Grid2>
                                </TableCell>
                                
                                <TableCell>
                                    <Grid2 container sx={{ width: 'auto', minWidth: '180px' }}>
                                        <Grid2>
                                            <Avatar sx={{ borderColor: '#0065FF', border: 1 }} alt={row.user_name} src={row.user_details.user_image || altProfile} />
                                        </Grid2>
                                        <Grid2 item sx={{ ml: '8px', textAlign: 'left' }}>
                                            <Grid2>
                                                <Typography>{row.user_details.user_name}</Typography>
                                            </Grid2>
                                            <Grid2>
                                                <Typography sx={{ color: '#83888E', fontSize: '12px' }}>
                                                    {row.user_details.user_phone_number}
                                                </Typography>
                                            </Grid2>
                                        </Grid2>
                                    </Grid2>
                                </TableCell>
                                <TableCell align="center">{row.chat_summary.last_message}</TableCell>
                                <TableCell align="center">
                                    {row.chat_summary.last_message_at 
                                        ? new Date(row.chat_summary.last_message_at).toLocaleString() 
                                        : 'N/A'}
                                </TableCell>
                                <TableCell align="center">
                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>

                                        <Button
                                            onClick={() => handleViewChat(row)}
                                            sx={{
                                                border: "1px solid #111418",
                                                color: "#111418",
                                                backgroundColor: "#ffffff",
                                                textTransform: "none",
                                                borderRadius: "12px",
                                                fontWeight: 500,
                                                minWidth: '120px',
                                                transition: "0.2s ease",
                                                "&:hover": {
                                                    backgroundColor: "#111418",
                                                    color: "#ffffff",
                                                    borderColor: "#111418"
                                                }
                                            }}
                                        >
                                            View Chat
                                        </Button>
                                    </Box>
                                </TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                {/* <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${ page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div> */}
            </TableContainer>

            <Snackbar
                open={snackbar}
                autoHideDuration={2000}
                onClose={handleSnackbarClose}
                message={message}
            />

            {OpenChat && (
                <div style={{
                    position: 'fixed',
                    top: 65,
                    right: 0,
                    height: '100%',
                    width: '80%',
                    display: 'flex',
                    backgroundColor: '#f5f5f5',
                    zIndex: 1000,
                }}>

                    {/* LEFT CHAT PANEL */}
                    <div style={{
                        width: detailsOpen ? "75%" : "100%",
                        backgroundColor: "#f9f9f9",
                        height: "100%",
                        overflowY: "auto",
                        padding: 20,
                        transition: "width 0.3s ease"
                    }}>
                        <Box>
                            <Typography variant="h6" style={{
                                marginBottom: '10px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <img src={BackIcon} alt="Back" onClick={handleCloseModal} style={{ cursor: 'pointer' }} />
                                <span style={{ marginLeft: '18px' }}>User Logs</span>
                            </Typography>

                            <Paper elevation={0}
                                style={{
                                    // padding: '7px 10px',
                                    maxWidth: '75vw',
                                    margin: '10px auto',
                                    backgroundColor: '#FFFFFF',
                                    borderRadius: '12px',
                                    border: '1px solid #DADADA',
                                }}>
                                <Grid2 container sx={{ justifyContent: 'space-between', alignItems: 'center', borderBottom:'1px solid #DADADA', padding:'10px',boxShadow: '0 2px 4px rgba(0,0,0,0.1)',}}>

                                    <Grid2 sx={{ display: 'flex', alignItems: 'center',gap: '15px',background:'#F5F5F5',padding:'10px 20px',borderRadius:'12px' ,ml:'10px'}}>
                                        <Grid2 sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Avatar alt="image" src={usercustomdata?.user_details?.user_image || altProfile} />
                                            <Grid2 item sx={{ ml: '8px' }}>
                                                <Typography sx={{ color: '#434343', fontSize: '12px' }}>Customer</Typography>
                                                <Typography>{usercustomdata?.user_details?.user_name}</Typography>
                                                {/* <Typography sx={{ color: '#83888E', fontSize: '12px' }}>
                                                    {usercustomdata?.user_details?.user_phone_number}
                                                </Typography> */}
                                            </Grid2>
                                        </Grid2>

                                        <Grid2>
                                            <img src={ConnectionIcon} alt="Connection" />
                                        </Grid2>
                                        <Grid2 sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Avatar alt="image" src={usercustomdata?.driver_details?.driver_image || altProfile} />
                                            <Grid2 item sx={{ ml: '8px' }}>
                                                <Typography sx={{ color: '#434343', fontSize: '12px' }}>Driver</Typography>

                                                <Typography >
                                                    {usercustomdata?.driver_details?.driver_name}
                                                </Typography>
                                            </Grid2>
                                        </Grid2>
                                    </Grid2>

                                <Grid2 sx={{ display: 'flex', alignItems: 'center' }}>

                                    <Grid2 item>
                                        {/* <IconButton onClick={() => setDetailsOpen(true)}>
                                            <img src={ActionButtonIcon} alt="Action" style={{ width: 40, height: 40 }} />
                                            </IconButton> */}
                                        <Button onClick={() => setDetailsOpen(true)} sx={{
                                            backgroundColor: '#FFF',
                                            color: '#1A1E25',
                                            borderRadius: '8px',
                                            padding: '6px 12px',
                                            marginRight: '8px',
                                            fontSize: '14px',
                                            fontWeight: 400,
                                            textTransform: 'none',
                                            border: '1px solid #1A1E25',
                                            '&:hover': {
                                                backgroundColor: '#1A1E25',
                                                color: '#fff',
                                            },
                                        }}>
                                            View Details
                                        </Button>
                                    </Grid2>

                                    <Grid2 xs="auto">
                                        <Button
                                            variant="contained"
                                            style={{
                                                width: "120px",
                                                height: "42px",
                                                backgroundColor: "#1A1E25",
                                                textTransform: "none",
                                                borderRadius: "8px",
                                                marginRight: "8px"
                                            }}
                                            onClick={() => toPDF()}
                                            disabled={!usercustomdata}
                                            >
                                                <Typography sx={{ color: "#fff", cursor: "pointer" }}>Export Chat</Typography>
                                        </Button>
                                    </Grid2>
                                </Grid2>
                             </Grid2>
                                <Grid2 xs={12} sx={{marginTop:'10px',overflowY:'auto',padding:'0px 10px'}}>
                                    <ChatService messages={usercustomdata.chat_messages} chatContext="DRIVER_USER" user={usercustomdata?.user_details} driver={usercustomdata?.driver_details} searchicon={false} />
                                </Grid2>

                            </Paper>
                            <Paper elevation={0}
                                style={{
                                    // padding: '7px 10px',
                                    maxWidth: '75vw',
                                    margin: '10px auto',
                                    backgroundColor: '#FFFFFF',
                                    borderRadius: '12px',
                                    border: '1px solid #DADADA',
                                        position: 'absolute', 
                                        top: '-10000px', 
                                        left: '-10000px', 
                                        width: '100%',
                                        height: 'auto'
                                }} ref={targetRef}>
                                <Grid2 container sx={{ justifyContent: 'space-between', alignItems: 'center', borderBottom:'1px solid #DADADA', padding:'10px',boxShadow: '0 2px 4px rgba(0,0,0,0.1)',}}>

                                    <Grid2 sx={{ display: 'flex', alignItems: 'center',gap: '15px',background:'#F5F5F5',padding:'10px 20px',borderRadius:'12px' ,ml:'10px'}}>
                                        <Grid2 sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Avatar alt="image" src={usercustomdata?.user_details?.user_image || altProfile} />
                                            <Grid2 item sx={{ ml: '8px' }}>
                                                <Typography sx={{ color: '#434343', fontSize: '12px' }}>Customer</Typography>
                                                <Typography>{usercustomdata?.user_details?.user_name}</Typography>
                                            </Grid2>
                                        </Grid2>

                                        <Grid2>
                                            <img src={ConnectionIcon} alt="Connection" />
                                        </Grid2>
                                        <Grid2 sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Avatar alt="image" src={usercustomdata?.driver_details?.driver_image || altProfile} />
                                            <Grid2 item sx={{ ml: '8px' }}>
                                                <Typography sx={{ color: '#434343', fontSize: '12px' }}>Driver</Typography>

                                                <Typography >
                                                    {usercustomdata?.driver_details?.driver_name}
                                                </Typography>
                                            </Grid2>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 sx={{ ml: 'auto' }}>
                                    <Typography sx={{ color: '#83888E', fontSize: '12px' }}>
                                        Engagement ID: {usercustomdata?.engagement_id}
                                    </Typography>
                                </Grid2>
                                </Grid2>
                                <Grid2 xs={12} sx={{marginTop:'10px',overflowY:'auto',padding:'0px 10px'}}>
                                    <ChatService messages={usercustomdata.chat_messages} chatContext="DRIVER_USER" user={usercustomdata?.user_details} driver={usercustomdata?.driver_details} searchicon={false} />
                                </Grid2>

                            </Paper>
                        </Box>
                    </div>

                    {/* RIGHT DETAILS PANEL */}
                    {detailsOpen && (
                        <div style={{
                            width: "55%",
                            height: "100%",
                            backgroundColor: "#F9F9F9",
                            borderLeft: "1px solid #e0e0e0",
                            padding: "20px 20px 200px 20px",
                            transition: "width 0.3s ease",
                            zIndex: 1100,
                        }}>

                            
                            <Typography variant="h6" style={{ marginBottom: 10, display: "flex", alignItems: "center" }}>
                                <IconButton onClick={() => setDetailsOpen(false)}>
                                    <CloseIcon />
                                </IconButton>
                                <span style={{ marginLeft: '10px', fontWeight: 600 }}>View Details</span>
                            </Typography>
                            <div style={{ overflowY: "auto", maxHeight: "100%" ,marginBottom: '100px'}}>

                            {/* DRIVER DETAILS */}
                            <Paper
                                style={{
                                    padding: '20px 20px 5px 20px',
                                    marginTop: '20px',
                                    backgroundColor: '#fff',
                                    borderRadius: '12px',
                                    boxShadow: 'none',
                                }}
                            >
                                <Typography style={{ fontWeight: 600, marginBottom: 10 }}>Driver Details</Typography>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 15 }}>
                                    <Avatar src={usercustomdata?.driver_details?.driver_image||defaultImg} sx={{ width: 60, height: 60 }} />
                                    <div style={{ marginLeft: 12 }}>
                                        <Typography style={{ fontWeight: 600 }}>{usercustomdata?.driver_details?.driver_name}</Typography>

                                        {/* Rating Row */}
                                        <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                                            <Rating value={(usercustomdata?.driver_details?.total_rating)/(usercustomdata?.driver_details?.no_of_rating)} readOnly />
                                            <Typography style={{ fontSize: 14, marginLeft: 6 }}>({usercustomdata?.driver_details?.no_of_rating} Reviews)</Typography>
                                        </div>
                                    </div>
                                </div>

                                {/* Details Grid */}
                                <Grid2 container spacing={2} sx={{ marginBottom: '10px' ,justifyContent: 'space-between'}}>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Driver ID</b><br />{usercustomdata?.driver_details?.driver_id}</Typography></Grid2>
                                    <Grid2 xs={6} sx={{marginLeft: '6rem'}}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Mobile Number</b><br />{usercustomdata?.driver_details?.driver_phone_number}</Typography></Grid2>
                                     <Grid2 xs={6}><Typography>{""}</Typography></Grid2>
                                </Grid2>
                                <Grid2 container spacing={2} sx={{ marginBottom: '10px' ,justifyContent: 'space-between'}}>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Email</b><br />{usercustomdata?.driver_details?.driver_email}</Typography></Grid2>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>City</b><br />{usercustomdata?.engagement_details?.city_name}</Typography></Grid2>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Trips</b><br />{usercustomdata?.driver_details?.total_trips}</Typography></Grid2>
                                </Grid2>
                            </Paper>


                            {/* RIDER DETAILS */}
                            <Paper
                                style={{
                                    padding: '20px 20px 5px 20px',
                                    marginTop: '20px',
                                    backgroundColor: '#fff',
                                    borderRadius: '12px',
                                    boxShadow: 'none',
                                }}
                            >
                                <Typography style={{ fontWeight: 600, marginBottom: 10 }}>Rider Details</Typography>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 15 }}>
                                    <Avatar src={usercustomdata?.user_details?.user_image|| altProfile} sx={{ width: 60, height: 60 }} />
                                    <div style={{ marginLeft: 12 }}>
                                        <Typography style={{ fontWeight: 400 }}>{usercustomdata?.user_details?.user_name}</Typography>

                                        {/* Rating */}
                                        <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                                            <Rating value={(usercustomdata?.user_details?.total_rating)/(usercustomdata?.user_details?.no_of_rating)} readOnly />
                                            <Typography style={{ fontSize: 14, marginLeft: 6 }}>({usercustomdata?.user_details?.no_of_rating} Reviews)</Typography>
                                        </div>
                                    </div>
                                </div>

                                {/* Details */}
                                <Grid2 container spacing={2} sx={{ marginBottom: '10px',justifyContent: 'space-between' }}>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>User ID</b><br />{usercustomdata?.user_details?.user_id}</Typography></Grid2>
                                    <Grid2 xs={6} sx={{marginLeft: '6rem'}}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Mobile Number</b><br />{usercustomdata?.user_details?.user_phone_number}</Typography></Grid2>
                                    <Grid2 xs={6}><Typography>{""}</Typography></Grid2>

                                </Grid2>
                                <Grid2 container spacing={2} sx={{ marginBottom: '10px',justifyContent: 'space-between' }}>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Email</b><br />{usercustomdata?.user_details?.user_email}</Typography></Grid2>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }} >City</b><br />{usercustomdata?.engagement_details?.city_name}</Typography></Grid2>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Trips</b><br />{usercustomdata?.user_details?.total_trips}</Typography></Grid2>
                                </Grid2>
                            </Paper>


                            {/* TRIP DETAILS */}
                            <Paper
                                style={{
                                    padding: '20px 20px 5px 20px',
                                    marginTop: '20px',
                                    backgroundColor: '#fff',
                                    borderRadius: '12px',
                                    boxShadow: 'none',
                                }}
                            >
                                <Typography style={{ fontWeight: 600, marginBottom: 10 }}>Trip Details</Typography>

                                <Grid2 container spacing={2} sx={{ marginBottom: '10px' ,justifyContent: 'space-between'}}>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Engagement ID</b><br />{usercustomdata?.engagement_id}</Typography></Grid2>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Booking Status</b><br />{constant.taxiEngagementStatusReverse[usercustomdata?.engagement_details?.status]}</Typography></Grid2>
                                     <Grid2 xs={6}><Typography>{""}</Typography></Grid2>
                                </Grid2>
                                <Grid2 container spacing={2} sx={{ marginBottom: '10px' ,justifyContent: 'space-between'}}>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Vehicle Type</b><br />{usercustomdata?.engagement_details?.vehicle_type}</Typography></Grid2>
                                    <Grid2 xs={6}  sx={{marginLeft: '7rem'}}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Ride start Time</b><br />{dayjs(usercustomdata?.engagement_details?.pickup_time).format("HH:mm:ss")}</Typography></Grid2>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Booking Distance</b><br />{usercustomdata?.engagement_details?.ride_distance} Km</Typography></Grid2>
                                </Grid2>
                                    <hr></hr>
                                {/* Locations */}
                                <div style={{ marginTop: 20 }}>
                                    <Typography style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={Pickupicon} alt="Pickup" style={{ width: 20, height: 20, marginRight: 8 }}/><span>Pickup Location</span>
                                    </Typography>
                                    <Typography style={{ fontWeight: 400, marginBottom: 10,marginLeft: '28px',fontSize: '14px' }}>
                                        {usercustomdata?.engagement_details?.pickup_address}
                                    </Typography>

                                    <Typography style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                        <img src={Dropicon} alt="Drop" style={{ width: 20, height: 20, marginRight: 8 }}/>  <span>Drop Location</span>
                                    </Typography>
                                    <Typography style={{ fontWeight: 400, marginBottom: 10,marginLeft: '28px',fontSize: '14px' }}>
                                        {usercustomdata?.engagement_details?.drop_address}
                                    </Typography>
                                </div>
                            </Paper>


                            {/* VEHICLE DETAILS */}
                            <Paper
                                style={{
                                    padding: '20px 20px 5px 20px',
                                    marginTop: '20px',
                                    backgroundColor: '#fff',
                                    borderRadius: '12px',
                                    boxShadow: 'none',
                                }}
                            >
                                <Typography style={{ fontWeight: 600, marginBottom: 10 }}>Vehicle Details</Typography>

                                <Grid2 container spacing={2}>
                                    <Grid2 xs={4}>
                                        <img src={Vehiclertypecar}
                                            alt="Car"
                                            style={{ width: 80 }}
                                        />
                                    </Grid2>
                                <Grid2 container sx={{ marginBottom: '10px' ,justifyContent: 'space-between',gap: '40px'    }}>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Vehicle Number</b><br />{usercustomdata?.vehicle_details?.vehicle_no}</Typography></Grid2>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Vehicle Type</b><br />{constant.VehicleTypes[usercustomdata?.vehicle_details?.vehicle_type]}</Typography></Grid2>
                                </Grid2>
                                </Grid2>
                            </Paper>


                            {/* PAYMENT DETAILS */}
                            <Paper
                                style={{
                                    padding: '20px 20px 5px 20px',
                                    marginTop: '20px',
                                    marginBottom: '160px',
                                    backgroundColor: '#fff',
                                    borderRadius: '12px',
                                    boxShadow: 'none',
                                }}
                            >
                                <Typography style={{ fontWeight: 600, marginBottom: 10 }}>Payment Details</Typography>

                                <Grid2 container spacing={2} sx={{ marginBottom: '10px' ,justifyContent: 'space-between'}}>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Payment Type</b><br />{constant.paymentMode[usercustomdata?.payment_details?.payment_mode]}</Typography></Grid2>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Fare</b><br />{usercustomdata?.payment_details?.trip_fare}</Typography></Grid2>
                                    <Grid2 xs={6}><Typography><b style={{ fontWeight: 400, color: "#1A1E25",fontSize: '12px' }}>Payment Status</b><br />{constant.paymentStatus[usercustomdata?.payment_details?.payment_status]}</Typography></Grid2>
                                </Grid2>
                            </Paper>
                            </div>

                        </div>
                    )}

                </div>
            )}

        </div>
    );
};

export default UserLogs;